import { apiCall, createQueryString } from "../imports"

// برای متدهای shallow از مسیر مستقل comments استفاده می‌شود
const FLAT_PREFIX = "clinicf/comments";
const NESTED_PREFIX = "clinicf/doctors";

export default {
    // با توجه به کنترلر شما، ایندکس می‌تواند به صورت مسطح همراه با کوئری doctor_id فراخوانی شود
    get(filters) {
        return apiCall('get', `${FLAT_PREFIX}${createQueryString(filters)}`)
    },
    show(id){
        return apiCall('get', `${FLAT_PREFIX}/${id}`)
    },
    // برای ایجاد نظر جدید (در صورت نیاز در پنل ادمین)
    create(doctorID, data) {
        return apiCall('post', `${NESTED_PREFIX}/${doctorID}/comments`, data)
    },
    update(id, data) {
        return apiCall('put', `${FLAT_PREFIX}/${id}`, data)
    },
    delete(id) {
        return apiCall('delete', `${FLAT_PREFIX}/${id}`)
    }
}
